/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Highlight_AddInputs */

const vi_shop_group_highlight_add = /** @type {(inputs: Shop_Group_Highlight_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm dòng`)
};

/**

* @param {Shop_Group_Highlight_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_highlight_add = /** @type {((inputs?: Shop_Group_Highlight_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Highlight_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_highlight_add(inputs)
});